import * as React from 'react';
import { TextField } from '@mui/material';


export default function FormNumberField({
    label,
    className='',
    name,
    value,
    onBlurUpdate,
    min='',
    max='',
    type='',
    error=false,
    helperText=false,
    width=false
}) {

    const [inputValue, setInputValue] = React.useState(value);
    const [inputType, setInputType] = React.useState('');

    React.useEffect(() => {
        setInputValue(value);
    },[value]);

    const keyDownChange = (e) => {

        if(["Backspace","Delete","Tab","Escape","ArrowLeft","ArrowRight","Enter"].includes(e.key)){
            return;
        }
        
        if(e.key === '+') {
            e.preventDefault();
        }
        if(type === "boolean" && (e.key === '-' || e.key === '.')){
            e.preventDefault();
        } 
        if(type === "int" && (e.key === '.' || !/^[0-9]$/.test(e.key)) ){
            e.preventDefault();
        } 
        if(!/^[0-9.]$/.test(e.key)){
            e.preventDefault();
        }
    }

    const handleChange = (e) => {
        let value = e.target.value;
        if(max !== '' && min !== ''){
            if (min.toString() && value < min)  { value = min } 
            if (max.toString() && value > max)  { value = max } 
        } 
        setInputValue(value);
        setInputType(e.target.type);
    } 

    const handleBlur = () => {
        onBlurUpdate(name,inputValue,inputType);
    } 
    
    return (
        <TextField
            sx={{ 
                width: { 
                    xs: '100%', 
                    sm:width === false ? '30%':'100%',  
                    md:width === false ? '24%':'100%' 
                } 
            }}   
            className={className}
            margin="dense"
            id={name}
            label={label}
            name={name}
            value={inputValue ?? ''}
            onKeyDown={keyDownChange}
            onBlur={handleBlur}
            onChange={handleChange}
            //onInput={handleInput}
            error={error && inputValue === ""}
            helperText={helperText && inputValue === "" ? "Required Field!" : false}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                inputProps: {
                  type: 'number',
                  min: min, max: max,
                },
              //  sx:{width: width === false ? 'auto'  : className === '' ? '190px' : 'auto'}
            }}
            //disabled={(min === 0 && max === 0) ? true : false }
        />
    )
}